<template>
  <v-col id="error-controls" cols="auto" class="pa-0 align-self-center">
    <v-btn v-if="!isShowingInvalidRows" variant="outlined" color="error">
      {{ $t('actions.showInvalidRows') }}
    </v-btn>
    <v-btn v-else variant="outlined" color="primary">
      {{ $t('actions.showAllRows') }}
    </v-btn>
  </v-col>
</template>

<script>
export default {
  name: 'ErrorControls',

  props: {
    invalidRowsMessage: {
      required: true,
      type: String,
    },
    isShowingInvalidRows: {
      required: true,
      type: Boolean,
    },
  },
};
</script>

<style scoped></style>
